export default {
  ebookPage: {
    all: { ID: 772, CN: "全部", TR: "All" },
    driveType: { ID: 1066, CN: "驱动类型", TR: "Drive type" },
    motor: { ID: 830, CN: "电机", TR: "Motor" },
    diesel: { ID: 1069, CN: "柴油机", TR: "Diesel engine" },
    noProfile: { ID: 2367, CN: "暂无简介", TR: "No Profile" },
    serieslist: { ID: 1, CN: "电子样本", TR: "Product Book" },
    motorFrequency: { ID: 72, CN: "电机频率", TR: "Motor Frequency" },
    motorStandard: { ID: "", CN: "Unit Standard", TR: "Unit Standard" },
    displayMode: { ID: 664, CN: "显示方式", TR: "Display Mode" },
    list: { ID: 665, CN: "列表", TR: "List" },
    grid: { ID: 666, CN: "网格", TR: "Grid" },
    keyWord: { ID: 661, CN: "关键词", TR: "Key word" },
    keyWordRule: { ID: 1003, CN: "请输入关键字", TR: "Please input key word" },
    view: { ID: 251, CN: "查询", TR: "View" },
    queryResults: { ID: 2368, CN: "查询结果", TR: "Query Results" },
    operation: { ID: 1012, CN: "操作", TR: "operation" },
    download: { ID: 448, CN: "下载", TR: "download" },
    type: { ID: 246, CN: "类型", TR: "type" },
    name: { ID: 446, CN: "名称", TR: "name" },
    updateTime: { ID: 758, CN: "更新时间", TR: "update time" },
    version: { ID: 759, CN: "文件版本", TR: "version" },
    lang: { ID: 449, CN: "语言", TR: "language" },
    size: { ID: 1489, CN: "文件尺寸", TR: "size" },
    desc: { ID: 447, CN: "描述", TR: "describe" },
    emptyFlowAndHead: { ID: 2426, CN: "流量和扬程不能为空", TR: "Flow and head cannot be empty" },
    details: { ID: 983, CN: "详情", TR: "Detail" },
    noData: { ID: "", CN: "暂无数据", TR: "No data available" },
    pumpList: { ID: 123, CN: "水泵列表", TR: "List" },
    spectrumList: { ID: 6, CN: "系列型谱", TR: "Spectrum" },
    modelDrawing: { ID: 183, CN: "实物图", TR: "Model Drawing" },
    seriesDescription: { ID: 145, CN: "系列说明", TR: "Series Description" },
    seriesDocuments: { ID: 687, CN: "系列文档", TR: "Series Documents" },
    video: { ID: 688, CN: "视频", TR: "Video" },
    model_3D: { ID: 132, CN: "三维模型", TR: "3D Model" },
    export: { ID: 277, CN: "导出", TR: "Export" },
    no: { ID: 689, CN: "序号", TR: "NO" },
    flow: { ID: 47, CN: "流量", TR: "Flow" },
    head: { ID: 48, CN: "扬程", TR: "Head" },
    catalog: { ID: 2337, CN: "按类型", TR: "By Catalog" },
    selectIndustry: { ID: 2369, CN: "选择行业", TR: "Select industry" },
    choosePump: { ID: "", CN: "选择泵型", TR: "Select pump" }, //yy加一个选择泵业
    allSeries: { ID: 1963, CN: "所有系列", TR: "All series" },
    productStructure: { ID: "", CN: "产品结构", TR: "Product Mix" },
    screen: { ID: "", CN: "筛选", TR: "Screen" },
    search: { ID: 177, CN: "搜索", TR: "Search" },
    deviceList: { ID: "", CN: "设备列表", TR: "Devices List" },
  },
  selectPage: {
    basicParameters: { ID: 1846, CN: "基本参数", TR: "Basic Parameters" },
    drive: { ID: "", CN: "驱动", TR: "Drive" },
    acceptanceTolerance: { ID: "", CN: "验收容差", TR: "Acceptance Tolerance" },
    toleranceStandard: { ID: "", CN: "容差标准", TR: "Tolerance Standard" },
    toleranceLevel: { ID: "", CN: "容差等级", TR: "Tolerance Level" },
    flowRange: { ID: "", CN: "流量范围", TR: "Flow Range" },
    headRange: { ID: "", CN: "扬程范围", TR: "Head Range" },
    otherSelectionCriteria: { ID: "", CN: "其他选型条件", TR: "Other Selection Criteria" },
    applicationArea: { ID: 2339, CN: "应用领域", TR: "Application Area" },
    municipalWaterManagement: { ID: "", CN: "市政", TR: "Municipal Administration" },
    industrialAndMining: { ID: "", CN: "工矿", TR: "Industrial And Mining" },
    constructionApplications: { ID: "", CN: "建筑", TR: "Construction" },
    filterCriteria: { ID: "", CN: "筛选结果", TR: "Filter Result" },
    selparas: { ID: 5, CN: "参数选型", TR: "Parameter Selection" },
    selResult: { ID: 2316, CN: "选型结果", TR: "Selection results" },
    index: { ID: 1451, CN: "首页", TR: "Home page" },
    selRow: { ID: 724, CN: "列选择", TR: "Column selection" },
    export: { ID: 277, CN: "导出", TR: "Export" },
    print: { ID: 193, CN: "打印", TR: "Print" },
    previous: { ID: 367, CN: "上一步", TR: "Previous step" },
    physical: { ID: 183, CN: "实物图", TR: "Model Drawing" },
    series: { ID: 254, CN: "系列", TR: "Series" },
    model: { ID: 100, CN: "型号", TR: "Model" },
    diagram: { ID: 766, CN: "曲线图", TR: "Curve graph" },
    flow: { ID: 47, CN: "流量", TR: "Flow" },
    head: { ID: 48, CN: "扬程", TR: "Head" },
    shaftPower: { ID: 109, CN: "轴功率", TR: "Shaft Power" },
    efficiency: { ID: 108, CN: "效率", TR: "Efficiency" },
    npsh: { ID: 110, CN: "汽蚀", TR: "NPSHr" },
    speed: { ID: 115, CN: "转速", TR: "Speed" },
    impellerDiameter: { ID: 224, CN: "叶轮直径", TR: "Impeller Diameter" },
    details: { ID: 983, CN: "详情", TR: "Detail" },
    certifiedTraffic: { ID: "", CN: "认证流量", TR: "Certified traffic" },
    certifiedHead: { ID: "", CN: "认证扬程", TR: "Certified head" },
    certifiedSpeed: { ID: "", CN: "认证转速", TR: "Certified speed" },
    pointFlow_150: { ID: "", CN: "150%点流量", TR: "150% point flow" },
    pointLift_150: { ID: "", CN: "150%点扬程", TR: "150% point lift" },
    pointPower_150: { ID: "", CN: "150%点功率", TR: "150% point power" },
    maxShaftPower: { ID: "", CN: "最大轴功率", TR: "Max shaft power" },
    deadCenterLift: { ID: "", CN: "关死点扬程", TR: "Dead center lift" },
    pumpStages: { ID: 769, CN: "泵级数", TR: "Pump stages" },
    note: { ID: 118, CN: "备注", TR: "Note" },
    gotoIndexPage: { ID: 2370, CN: "返回首页", TR: "Back to home" },
    quickSelection: { ID: 2317, CN: "快速选型", TR: "Quick selection" },
    advancedSelection: { ID: 2318, CN: "高级选型", TR: "Advanced selection" },
    workingConditions: { ID: 2319, CN: "工况条件", TR: "Operating conditions" },
    productSeries: { ID: 2320, CN: "产品系列", TR: "Product series" },
    driveType: { ID: 2321, CN: "驱动类型", TR: "Drive type" },
    setFrequency: { ID: 2322, CN: "设置频率", TR: "Set frequency" },
    moreDesignPoints: { ID: 1443, CN: "更多设计点", TR: "More design points" },
    hide: { ID: 2323, CN: "隐藏", TR: "hide" },
    secondDpFlow: { ID: 2324, CN: "第二设计点流量", TR: "Second design point flow" },
    secondDpHead: { ID: 2325, CN: "第二设计点扬程", TR: "Second design point head" },
    thirdDpFlow: { ID: 2326, CN: "第三设计点流量", TR: "Third design point flow" },
    thirdDpHead: { ID: 2327, CN: "第三设计点扬程", TR: "Third design point head" },
    firePump: { ID: 2289, CN: "消防泵", TR: "Fire pump" },
    motorPoleNum: { ID: 2328, CN: "电机级数", TR: "Motor series" },
    moreSet: { ID: 2329, CN: "更多设置", TR: "More settings" },
    put: { ID: 2330, CN: "收起", TR: "Put away" },
    expand: { ID: "",CN:"展开", TR: "Expand" },
    motorPowerStd: { ID: 2331, CN: "电气标准", TR: "Motor power standard" },
    mediaName: { ID: 2332, CN: "介质名称", TR: "Media name" },
    mediumTemperature:{ID:"",CN:"介质温度",TR:"Medium Temperature"},
    cleanWater: { ID: 464, CN: "清水", TR: "Clean water" },
    maxTemperature: { ID: 2333, CN: "最高温度", TR: "maximum temperature" },
    customMediaProp: { ID: 2334, CN: "自定义介质属性", TR: "Custom media properties" },
    maxDensity: { ID: 2335, CN: "最大密度", TR: "Maximum density" },
    mediumViscosity: { ID: 2336, CN: "介质粘度", TR: "Medium viscosity" },
    nextStep: { ID: 368, CN: "下一步", TR: "Next" },
    selectAll: { ID: 97, CN: "全选", TR: "Select All" },
    reselect: { ID: 366, CN: "取消全选", TR: "Reselect" },
    invert: { ID: "", CN: "反选", TR: "Invert" },
    modelList: { ID: 442, CN: "型号列表", TR: "Model List" },
    byType: { ID: 2337, CN: "按类型", TR: "By type" },
    byIndustry: { ID: 2338, CN: "按行业", TR: "By industry" },
    byMedia: { ID: 2371, CN: "按介质", TR: "By media" },
    type: { ID: 246, CN: "类型", TR: "Type" },
    applicationArea: { ID: 2339, CN: "应用领域", TR: "Application area" },
    flowRule: { ID: 2553, CN: "请输入流量", TR: "Please input flow" },
    headRule: { ID: 1149, CN: "请输入扬程", TR: "Please enter the head" },
    leastOneType: { ID: "", CN: "至少选择一种类型", TR: "Select at least one type" },
    seriesRule: { ID: 2342, CN: "至少选择一个系列", TR: "Select at least one series" },
    hangyeRule: { ID: 2372, CN: "至少选择一个行业", TR: "Select at least one industry" },
    jiezhiRule: { ID: 2373, CN: "至少选择一种介质", TR: "Select at least one media" },
    dieselEngineSpeedRule: { ID: 2341, CN: "请输入柴油机转速", TR: "Please enter the diesel engine speed" },
    dieselEngineSpeed: { ID: 2340, CN: "柴油机转速", TR: "Diesel engine speed" },
    pleaseSelect: { ID: 2022, CN: "请选择", TR: "Please select" },
    custom: { ID: 2180, CN: "自定义", TR: "custom" },
    unlimited: { ID: "", CN: "不限", TR: "unlimited" },
    drivingConditions: { ID: "", CN: "驱动条件", TR: "Driving conditions" },
    toleranceRange: { ID: 51, CN: "容差范围", TR: "Tolerance Range" },
    toleranceStand: { ID: "", CN: "验收容差标准", TR: "Acceptance tolerance criteria", },
    toleranceGrade: { ID: "", CN: "验收容差等级", TR: "Acceptance tolerance level", },
    MinFlowPercentage: { ID: 677, CN: "最小流量百分比", TR: "Minimum flow percentage", },
    MaxFlowPercentage: { ID: 678, CN: "最大流量百分比", TR: "Maximum flow percentage", },
    MinHeadPercentage: { ID: 679, CN: "最小扬程百分比", TR: "Minimum head percentage", },
    MaxHeadPercentage: { ID: 680, CN: "最大扬程百分比", TR: "Maximum head percentage", },
    findErr1: { ID: "", CN: "未查找到相关型号,请修改相关选型参数", TR: "No relevant model found, please modify relevant model selection parameters", },
    findErr2: { ID: "", CN: "未查找到相关型号,将在三秒后返回上一页", TR: "No relevant model found, will return to the previous page in three seconds", },
    seriesTips: { ID: "", CN: "请选择合适的产品", TR: "Please choose the right product" },
    seriesRangTips: { ID: "", CN: "请选择合适的产品系列", TR: "Please select the appropriate product line" },
    seriesRange: { ID: "", CN: "系列范围", TR: "Range of series" },
    QPerQBep: { ID: "", CN: "额定点", TR: "Rated point" },
    PerRated: { ID: "", CN: "铭牌参数综合偏差", TR: "Nameplate parameter deviation value", },
    PerRatedQ: { ID: "", CN: "铭牌参数流量偏差",TR:"Nameplate Parameter Flow Deviation" },
    sortMethod: { ID: "", CN: "排序方式", TR: "Sort Order" },
    efficiencySort: { ID: "", CN: "效率排序", TR: "Efficiency Sort" },
    qPerQBepSort: { ID: "", CN: "综合排序", TR: "Compre Sort" },
    enum: { ID: 331, CN: "数量", TR: "number" },
    modelSelection: { ID: 26, CN: "选型", TR: "model Selection" },
    mediaLibrary: { ID: "", CN: "介质库", TR: "Media Library" },
    volumeConcentration: { ID: "", CN: "体积浓度", TR: "Volume concentration" },
    mediaDescription: { ID: "", CN: "介质说明", TR: "Media Description" },
    isMediumParticles: { ID: "", CN: "含有介质颗粒", TR: "Does it contain medium particles" },
    vbr: { ID: "", CN: "变速率", TR: "VBR" },
    cuttingRate: { ID: "", CN: "切割率", TR: "Cutting rate" },
    salesPrice: { ID: "", CN: "销售价", TR: "Sales Price" },
    originalImpellerDiameter: { ID: "", CN: "原始叶轮直径", TR: "Original impeller diameter" },
    ratedSpeed: { ID: "", CN: "额定转速", TR: "Rated Speed" },
    guidePrice: { ID: "", CN: "指导价", TR: "Guide Price" },
    secondDirectory: { ID: "", CN: "二级目录", TR: "Secondary directory" },
    allowCutting: { ID: "",CN:"允许切割", TR: "Allow Cutting" },
    allowFrequencyConversion: { ID: "",CN:"允许变频", TR: "Allow Frequency Conversion"},
    efficiencyAndNPSH: { ID: "", CN: "效率和汽蚀", TR: "Efficiency And NPSHr" },
    minimumEfficiency: { ID: "", CN: "最低效率", TR: "Min Efficiency" },
    attributeFiltering: { ID: "", CN: "属性过滤", TR: "Attribute Filtering" },
    importedCaliber: { ID: "", CN: "进口口径", TR: "Imported Caliber" },
    exportCaliber: { ID: "", CN: "出口口径", TR: "Export Caliber" },
    motorParameters: { ID: "", CN: "电机参数", TR: "Motor Parameters" },
    helpChoose: { ID: "", CN: "帮我选", TR: "Help Choose" },

    similarConversion:{ID:"",CN:"相似换算",TR:"Similarity Conversion"},
    parameterDesign:{ID:"",CN:"参数设计",TR:"Parameter Design"},
    selectionCondition:{ID:"",CN:"选型条件",TR:"Selection Conditions"},
    designRequirement:{ID:"",CN:"设计要求",TR:"Design Requirements"},
    calculationParameters:{ID:"",CN:"计算参数",TR:"Calculated Parameters"},
    mediumDensity:{ID:"",CN:"介质密度",TR:"Medium Density"},
    selectionMethod:{ID:"",CN:"选型方法",TR:"Selection Method"},
    pumpType:{ID:"",CN:"泵型",TR:"Pump Type"},
    impellerType:{ID:"",CN:"叶轮类型",TR:"Impeller Type"},
    modelLibrary:{ID:"",CN:"模型库",TR:"Model Library"},
    fixedSpeed:{ID:"",CN:"定转速",TR:"Fixed Speed"},
    specificSpeed:{ID:"",CN:"比转速",TR:"NS"},
    convertRangeBySpecificSpeed:{ID:"",CN:"比转速换算范围",TR:"Specific Speed Conversion Range"},
    efficiencyCorrection:{ID:"",CN:"效率修正",TR:"Efficiency Correction"},
    recommendModel:{ID:"",CN:"推荐模型",TR:"Recommend Model"},
    DifferenceInSpecificSpeed:{ID:"",CN:"比转速差值",TR:"Specific Speed Difference"},
    originalModelInformation:{ID:"",CN:"原模型信息",TR:"Original Model Information"},
    afterConversion:{ID:"",CN:"换算后",TR:"After Conversion"},
    scaleRatio:{ID:"",CN:"缩放系数",TR:"Scaling Factor"},
    yelunTips: { ID: "", CN: "请输入叶轮直径",TR:"Please Enter The Impeller Diameter"},
    e_requirements:{ID:"",CN:"效率要求",TR:"Efficiency Requirements"},
    currentMotorPower:{ID:"",CN:"当前电机功率",TR:"Current Motor Power"},
    requiredMotorPower:{ID:"",CN:"要求的电机功率",TR:'Required Motor Power'}, 
  },
  //详情页面
  detailPage: {
    userUnit: { ID: 2117, CN: "用户单位", TR: "User unit" },
    standardUnit: { ID: 2118, CN: "标准单位", TR: "Standard unit" },
    report: { ID: 692, CN: "报告", TR: "Report" },
    share: { ID: 693, CN: "分享", TR: "Share" },
    costAnalysis: { ID: 570, CN: "成本分析", TR: "Cost Analysis" },
    medium: { ID: 1448, CN: "介质", TR: "Medium" },
    model_3D: { ID: 132, CN: "三维模型", TR: "3D Model" },
    motorPower: { ID: 682, CN: "电机功率", TR: "Motor Power" },
    scanQRShare: { ID: 2354, CN: "扫描二维码分享", TR: "Scan QR code sharing" },
    view: { ID: 251, CN: "查询", TR: "View" },
    close: { ID: 459, CN: "关闭", TR: "Close" },
    setUp: { ID: 469, CN: "设定", TR: "Set Up" },
    flowUnits: { ID: 2102, CN: "流量单位", TR: "Flow Units" },
    headUnit: { ID: 2103, CN: "扬程单位", TR: "Head Unit" },
    powerUnit: { ID: 2355, CN: "功率单位", TR: "Power Unit" },
    npshUnit: { ID: "", CN: "汽蚀单位", TR: "NPSHr Unit" },
    d2Unit: { ID: "", CN: "叶轮外径单位", TR: "D2 Unit" },
    followSystem: { ID: "", CN: "跟随系统", TR: "Follow system" },
    exitFull: { ID: 2356, CN: "退出全屏", TR: "Exit Full" },
    partNo: { ID: 159, CN: "产品编号", TR: "Part No" },
    materialGroup: { ID: 1715, CN: "材料组", TR: "Material Group" },
    material: { ID: 1199, CN: "材料", TR: "Material" },
    selectionReport: { ID: 237, CN: "选型报告", TR: "Selection Report" },
    lang: { ID: 449, CN: "语言", TR: "Language" },
    fileFormat: { ID: 1547, CN: "文件格式", TR: "File Format" },
    buildFile: { ID: 2343, CN: "生成文件", TR: "Bulid File" },
    customerInfo: { ID: 780, CN: "客户信息", TR: "Customer Info" },
    orderInformation: { ID: 866, CN: "订单信息", TR: "Order Information" },
    reportInformation: { ID: "", CR: "报告信息",TR:"Report Infomation" },
    setReportContent: { ID: 871, CN: "设置报告内容", TR: "Set report content" },
    projectInformation: { ID: 89, CN: "项目信息", TR: "Project Information" },
    productName: { ID: 863, CN: "产品名称", TR: "Product name" },
    projectCode: { ID: 1011, CN: "项目编号", TR: "Project Code" },
    projectName: { ID: 785, CN: "项目名称", TR: "Project name" },
    itemNO: { ID: 786, CN: "工位编号", TR: "Item NO" },
    customerName: { ID: 865, CN: "客户名称", TR: "Customer Name" },
    customerAddress: { ID: 952, CN: "客户地址", TR: "Customer Address" },
    contactPerson: { ID: 753, CN: "联系人", TR: "Contact Person" },
    contactInformation: { ID: 35, CN: "联系方式", TR: "Contact Information" },
    email: { ID: 1803, CN: "邮箱", TR: "Email" },
    website: { ID: 1804, CN: "网址", TR: "Website" },
    country: { ID: 1805, CN: "国家", TR: "Country" },
    price: { ID: 868, CN: "产品单价", TR: "Product Price" },
    productModel: { ID: "", CN: "订单中产品型号", TR: "Model in the Order" },
    pumpPeformance: { ID: 1798, CN: "订单号", TR: "Order No" },
    purchaseQuantity: { ID: 870, CN: "购买数量", TR: "Purchase Quantity" },
    orderNote: { ID: 867, CN: "订单备注", TR: "Order Note" },
    pageReportSet: { ID: 2352, CN: "页面报告设置", TR: "Page Settings" },
    isBWDispplay: { ID: 804, CN: "黑白显示曲线", TR: "Black and white display", },
    dataAndCurve: { ID: 801, CN: "数据表和曲线", TR: "The data sheet and performance curve", },
    curveGraph: { ID: 766, CN: "曲线图", TR: "Performance curve" },
    sizePicture: { ID: 694, CN: "尺寸图", TR: "Dimension Picture" },
    assemblyDrawing: { ID: 134, CN: "安装图", TR: "Assembly Drawing" },
    modelDrawing: { ID: 183, CN: "实物图", TR: "Model Drawing" },
    explosionDiagram: { ID: "", CN: "爆炸图", TR: "Explosion picture" },
    modelDrawinUnit: { ID: 2353, CN: "实物图(机组)", TR: "Model Drawing(system)" },
    structureDrawing: { ID: 185, CN: "结构图", TR: "Structure Drawing" },
    outlineDrawing: { ID: "", CN: "安装尺寸图", TR: "Outline Drawing" },
    pumpDimensions: { ID: "", CN: "泵头尺寸图", TR: "Pump Dimensions" },
    offerText: { ID: 798, CN: "报价文本", TR: "Offer Text" },
    companyName: { ID: 995, CN: "公司抬头", TR: "Company Name" },
    companyWebsite: { ID: 1801, CN: "公司网址", TR: "Company Website" },
    performanceCurve: { ID: 218, CN: "性能曲线", TR: "Performance Curve" },
    assemblyDrawingPart: { ID: 2344, CN: "安装图(单泵)", TR: "Assembly Drawing(Pump)" },
    assemblyDrawingSys: { ID: 2345, CN: "安装图(机组)", TR: "Assembly Drawing(unit)" },
    physical: { ID: 183, CN: "实物图", TR: "Model Drawing" },
    parameter: { ID: 111, CN: "参数", TR: "Parameter" },
    productFileName: { ID: 694, CN: "尺寸图", TR: "Dimension picture" },
    data: { ID: 2026, CN: "数据", TR: "Data" },
    unit: { ID: 526, CN: "单位", TR: "Unit" },
    operatingParameters: { ID: 2126, CN: "运行参数", TR: "Operating params" },

    parameterQuery: { ID: 2346, CN: "参数查询", TR: "Parameter Query" },
    installation: { ID: 2169, CN: "安装信息", TR: "Installation" },
    motor: { ID: 2170, CN: "电机信息", TR: "Motor" },
    documents: { ID: 687, CN: "系列文档", TR: "Documents" },
    properties: { ID: 230, CN: "属性", TR: "Properties" },
    flow: { ID: 47, CN: "流量", TR: "Flow" },
    head: { ID: 48, CN: "扬程", TR: "Head" },
    frequency: { ID: "", CN: "频率", TR: "frequency" },

    seriesConnect: { ID: "", CN: "串联", TR: "Series Connect" },
    parallelConnect: { ID: "", CN: "并联", TR: "Parallel Connect" },
    method: { ID: "", CN: "方式", TR: "Method" },
    update: { ID: "", CN: "更新", TR: "Update" },
    number: { ID: "", CN: "台数", TR: "Number" },
    queryParams: { ID: "", CN: "查询参数",TR:"Query Params" },

    shaftPower: { ID: 109, CN: "轴功率", TR: "Shaft Power" },
    efficiency: { ID: 108, CN: "效率", TR: "Eta" },
    inputPower: { ID: "", CN: "输入功率",TR:"Input Power" },
    unitEfficiency: { ID: "", CN: "机组效率",TR:"Unit Efficiency"},
    press: { ID: 1105, CN: "压力", TR: "Press" },
    power: { ID: 422, CN: "功率", TR: "Power" },
    impellerDia: { ID: 112, CN: "叶轮外径", TR: "Impeller Dia" },
    npsh: { ID: 110, CN: "汽蚀", TR: "NPSHr" },
    speed: { ID: 115, CN: "转速", TR: "Speed" },
    coefficient: { ID: "", CN: "系数", TR: "Coefficient" },
    parameterSelection: { ID: 5, CN: "参数选型", TR: "Parameter Selection" },
    allowableRegionMax: {
      ID: 2347,
      CN: "允许区域(大)",
      TR: "Allowable Region(max)",
    },
    allowableRegionMin: {
      ID: 2348,
      CN: "允许区域(小)",
      TR: "Allowable Region(min)",
    },
    optimalAreaMax: { ID: 2349, CN: "最优区域(大)", TR: "Optimal Region(max)" },
    optimalAreaMin: { ID: 2350, CN: "最优区域(小)", TR: "Optimal Region(min)" },
    closeDeadCenter: { ID: 2351, CN: "关死点", TR: "Close Dead Center" },
    bestAdvantage: { ID: 2357, CN: "最优点", TR: "Best Advantage" },
    workingPoint: { ID: 203, CN: "工作点", TR: " Working Point" },
    flowPoint150: { ID: 2358, CN: "流量150%点", TR: "Flow 150% point" },
    powerPointMax: { ID: 2359, CN: "最大功率点", TR: "Maximum Power Point" },
    video: { ID: 688, CN: "视频", TR: "Series Video" },
    picture: { ID: "",CN: "图片", TR: "Picture" },
    variableSpeedCurve: {
      ID: 2374,
      CN: "变速曲线",
      TR: "Variable speed curve",
    },
    seriesParallelConnection: {
      ID: "",
      CN: "串并联曲线",
      TR: "Connection Curve",
    },
    displaySettings: { ID: 1625, CN: "显示设置", TR: "Display settings" },
    curveExport: { ID: 2375, CN: "曲线导出", TR: "Curve export" },
    chartColor: { ID: 2376, CN: "图表颜色", TR: "Chart color" },
    monochrome: { ID: 139, CN: "单色", TR: "monochrome" },
    multicolour: { ID: "", CN: "彩色", TR: "multicolour" },
    spectrumDisplay: { ID: 2377, CN: "型谱显示", TR: "spectrum display" },
    display: { ID: 217, CN: "显示", TR: "display" },
    noDisplay: { ID: 158, CN: "不显示", TR: "no display" },
    display_curve: {
      ID: "",
      CN: "显示在曲线末端",
      TR: "Display at the End of the Curve",
    },
    displayPanel: {
      ID: "",
      CN: "显示在面板",
      TR: "Display on the Panel",
    },
    onlyShowworkCurve: {
      ID: 1969,
      CN: "仅显示工作曲线",
      TR: "show only working curves",
    },
    speedList: { ID: 2378, CN: "速度列表", TR: "Speed list" },
    addSpeed: { ID: 2379, CN: "添加速度", TR: "add speed" },
    addPinLv: { ID: 2379,CN:"添加频率", TR: "Add Frequency" },
    pleaseEnterSpeed: {
      ID: 1154,
      CN: "请输入转速",
      TR: "Please enter the speed",
    },
    pleaseEnterHz: { ID: "", CN: "请输入频率", TR: "Please enter frequency" },
    tip: { ID: 286, CN: "提示", TR: "tip" },
    define: { ID: 125, CN: "确定", TR: "ok" },
    cancel: { ID: 126, CN: "取消", TR: "cancel" },
    download: { ID: 448, CN: "下载", TR: "download" },
    downloadTips: {
      ID: "",
      CN: "请下载桌面程序,导出性能曲线",
      TR: "Please download the desktop program and export the performance curve",
    },
    curve: { ID: 766, CN: "曲线图", TR: "Curve graph" },
    document: { ID: 984, CN: "文档", TR: "Document" },
    DocumentNone: { ID: "", CN: "文档(无)", TR: "Document (none)" },
    Model: { ID: "", CN: "模型", TR: "Model" },
    queryPoint: { ID: "", CN: "查询点", TR: "Query point" },
    productNoSelect: { ID: "", CN: "产品编号选择", TR: "Product No Select" },
    watermark: { ID: "", CN: "水印", TR: "Watermark" },
    IsPrintModel3d: { ID: "", CN: "产生三维页面", TR: "3D page generated" },
    IsCreateMultiSpeedChart: { ID: "",CN:"产生变频曲线", TR: "Variable Speed Curve Generated" },
    queryCurve: { ID: "", CN: "查询曲线", TR: "Query Curve" }, //yy  add---
    parameterQuery: { ID: "", CN: "参数查询", TR: "parameter query " },
    parameter_s: { ID: "", CN: "参数", TR: "parameter" },
    parameterCancel: { ID: "", CN: "取消", TR: "cancellation" },
    parameterDetermine: { ID: "", CN: "确定", TR: "determine" },
    showDesignPoints: {
      ID: "",
      CN: "显示设计点",
      TR: "Show Design Points",
    },
    designPointStyle: { ID: "", CN: "设计点样式", TR: "Design point styles" },
    crosshair: { ID: "", CN: "十字线", TR: "Crosshair" },
    invertedTriangle: {
      ID: "",
      CN: "倒三角",
      TR: "Inverted triangle",
    },
    roundDot: { ID: "", CN: "圆点", TR: "round dot" },
    boldRightAngle: { ID: "", CN: "加粗直角", TR: "Bold Right Angle" },
    deviceCurve: { ID: "", CN: "装置曲线", TR: "System Curve" },
    displayIndex: { ID: "", CN: "显示", TR: "display" },
    netHeadValue: { ID: "", CN: "净扬程值", TR: "Net head value" },
    displayCurve: { ID: "", CN: "显示曲线", TR: "Display Curve" },
    onlyDisplayCurve: {
      ID: "",
      CN: "仅显示工作曲线",
      TR: "Display only working curves",
    },
    showAllCurves: { ID: "", CN: "显示所有曲线", TR: "Show all curves" },
    outputChartToCAD: {
      ID: "",
      CN: "请下载客户端,客户端才能导出CAD格式文件",
      TR: "Please download the client to export CAD format files",
    },

    inquiry: { ID: "", CN: "询价", TR: "Inquiry" },
    productInquiry: { ID: "", CN: "产品询价", TR: "Product Inquiry" },
    address: { ID: "", CN: "地址", TR: "Address" },
    contactName: { ID: "", CN: "联系人名称", TR: "Contact Name" },
    pumpModel: { ID: "", CN: "泵型号", TR: "Pump Model" },
    pumpNumber: { ID: "", CN: "泵数量", TR: "Pump Number" },
    submit: { ID: "", CN: "提交", TR: "Submit" },
    inquirtFormatte1: {
      ID: "",
      CN: "请输入联系方式",
      TR: "Please enter contact information",
    },
    inquirtFormatte2: {
      ID: "",
      CN: "请输入联系人名称",
      TR: "Please enter the contact name",
    },
    selectMedia: {
      ID: "",
      CN: "选择介质",
      TR: "Select Media",
    },
    cleanWater: {
      ID: 459,
      CN: "清水",
      TR: "Clean water",
    },
    viewDetail: {
      ID: 661,
      CN: "查看详情",
      TR: "viewDetail",
    },
    sewage: {
      ID: 21,
      CN: "污水",
      TR: "sewage",
    },
    viscousSlurry: {
      ID: "",
      CN: "污水、渣浆粘稠浆液",
      TR: "Sewage, slurry, viscous slurry",
    },
    chemicalLiquid: {
      ID: "",
      CN: "化学液体",
      TR: "chemicalLiquid",
    },
    hydrocarbons: {
      ID: "",
      CN: "化学液体、烃类等",
      TR: "Chemical liquids, hydrocarbons, etc",
    },
    Gas: {
      ID: "",
      CN: "气体",
      TR: "Газ",
    },
    gasList: {
      ID: "",
      CN: "空气、油气、瓦斯",
      TR: "Air, oil and gas",
    },
    nameplateParameter: { ID: 2194, CN: "铭牌参数", TR: "nameplate parameter" },
    angle: { ID: 1500, CN: "角度", TR: "angle" },
    printCompanyInfo: { ID: "", CN: "打印公司信息", TR: "Print company information" },
    auto: { ID: "", CN: "自动判断", TR: "auto" },
    original: { ID: "", CN: "原始方向", TR: "original" },
    clockwise: { ID: "", CN: "顺时针方向", TR: "clockwise" },
    counterclockwise: { ID: "", CN: "逆时针方向", TR: "anticlockwise" },

    resize:{ID:"",TR:"Resize"},
    zoomIn:{ID:"",TR:"Zoom In"},
    zoomOut:{ID:"",TR:"Zoom Out"},
    highlightModifyArea:{ID:"",TR:"Highlight Modify Area"},
    move:{ID:"",TR:"Move"},

    productConfig:{ID:"",CN:"产品配置",TR:"Product Config"},
    exportSettings:{ID:"",CN:"导出设置",TR:"Export Settings"},
    path:{ ID: "", CN:"路径", TR:"Path" },
    monochromeDisplay:{ ID: "", CN:"单色显示", TR:"Monochrome Display" },
    chartSettings:{ ID: "", CN:"图表设置", TR:"Chart Settings" },
    selectionPoint:{ ID: "", CN:"选型点", TR:"Selection Point" },
    nameplateParameterPoints:{ ID: "", CN:"铭牌参数点", TR:"Parameter Point on nameplate" },
    operatingArea:{ ID: "", CN:"运行区域", TR:"Operating Region" },
    optimalArea:{ ID: "", CN:"最优区域", TR:"Optimal Region" },
    deviceArea:{ ID: "", CN:"装置曲线", TR:"System Curve" },
    flowHeadLine:{ ID: "", CN:"流量扬程线", TR:"Flow-Head Curve" },
    flowEfficiencyLine:{ ID: "", CN:"流量效率线", TR:"Flow-Efficiency Curve" },
    onlyWorkingCurve:{ ID: "", CN:"仅工作曲线", TR:"Working point curve only" },
    flowPowerLine: { ID: "", CN:"流量功率线", TR:"Flow-Power Curve" },
    textContent:{ ID: "", CN:"文本内容", TR:"Text Content" },
    rotationAngle:{ ID: "", CN:"旋转角度", TR:"Rotation Angle" },
    fontSize:{ ID: "", CN:"文字大小", TR:"Font Size" },
    alignmentMethod:{ ID: "", CN:"对齐方式", TR:"Alignment Method" },
    fontColor:{ ID: "", CN:"文字颜色", TR:"Font Color" },
    blod:{ ID: "", CN:"加粗", TR:"Blod" },
    italic:{ ID: "", CN:"倾斜", TR:"Italic" },
    leftRotation:{ ID: "", CN:"左旋转", TR:"Left Rotation" },
    rightRotation:{ ID: "", CN:"右旋转", TR:"Right Rotation" },
    equivalentLine:{ ID: "", CN:"等效线", TR:"Equivalent Line" },
    minFlowCurve: { ID: "", CN: "最小连续流量线",TR:"Min Flow Curve" },
    maximumEfficiencyPoint: { ID: "", CN: "高效点",TR:"Maximum Efficiency Point" },
    allCurves:{ ID: "", CN:"所有曲线", TR:"All Curves" },
    flowNPSHrCurve:{ ID: "", CN:"流量汽蚀线", TR:"Flow NPSHr Curve"},
    colorStyle:{ID: "", CN:"颜色样式", TR:"Color Style"},
    maxMinWorkingCurve: { ID: "", CN: "最大最小工作曲线",TR:"Max. and Min. Operating Curves" },
    errorTip: { ID: "", CN: "不能小于最小轴功率",TR:"Cannot be less than the minimum Shaft Power"},

    addCurve: { ID: "",CN:'添加曲线', TR: "Add Curve"},
    addFlowPoint: { ID: "", CN: "添加流量点", TR: "Add Flow Point"},
    byFrequency: { ID: "", CN: "按频率", TR: "By Frequency"},
    bySpeed: { ID: "", CN: "按转速", TR: "By Speed"},
    byOperatingPoint: { ID: "", CN: "按运行点", TR: "By Operating Point"},
    queryInfo: { ID: "", CN: "查询信息", TR: "Query Info"},
    pointName: { ID: "", CN: "点名", TR: "Point Name"},
  },
  //报表分析
  LCC: {
    Analysis: { ID: 568, CN: "分析", TR: "Analysis" },
    accumulationCurve: {
      ID: 927,
      CN: "年度累计曲线",
      TR: "Annual Accumulation Curve",
    },
    statisticalChart: {
      ID: 928,
      CN: "单年统计图",
      TR: "Statistical Chart of Year",
    },
    workingPointFlow: { ID: 554, CN: "工作点流量", TR: "working point flow" },
    default: { ID: 921, CN: "默认", TR: "default" },
    heating: { ID: 922, CN: "供暖", TR: "heating" },
    pressurize: { ID: 923, CN: "增压", TR: "pressurize" },
    custom: { ID: 924, CN: "自定义", TR: "custom" },
    status: { ID: 851, CN: "状态", TR: "status" },
    flowRatio: { ID: 932, CN: "流量比例", TR: "flow ratio" },
    timeScale: { ID: 933, CN: "时间比例", TR: "time scale" },
    fullLoad: { ID: 934, CN: "全负荷", TR: "full load" },
    partialLoad: { ID: 936, CN: "部分负荷", TR: "partial load" },
    nightCoolingOperation: {
      ID: 938,
      CN: "夜间降温运行",
      TR: "night cooling operation",
    },
    lowLoad: { ID: 937, CN: "低负荷", TR: "low load" },
    load: { ID: 2381, CN: "负荷", TR: "load" },
    energyCosts: { ID: 560, CN: "能耗成本", TR: "energy costs" },
    workingDays: { ID: 555, CN: "每年大致工作天数", TR: "working days" },
    workingHours: { ID: 556, CN: "每年大致工作小时", TR: "working hours" },
    powerFees: { ID: 566, CN: "电费", TR: "Electricity fees" },
    per: { ID: 564, CN: "每度", TR: "per" },
    risiPowerPrice: { ID: 2382, CN: "电费上涨", TR: "risi power price" },
    eachYear: { ID: 565, CN: "每年", TR: "each year" },
    CalcCycle: { ID: 557, CN: "计算周期", TR: "calculation cycle" },
    year: { ID: 558, CN: "年", TR: "Year" },
    interestRate: { ID: 559, CN: "利率", TR: "interest rate" },
    droop: { ID: 567, CN: "效率下降", TR: "efficiency droop" },
    co2Ratio: { ID: 920, CN: "CO2系数", TR: "CO2 ratio" },
    conversionFactor: { ID: 2427, CN: "煤炭折算系数", TR: "conversion factor" },
    maintenanceCost: { ID: 535, CN: "维护维修成本", TR: "maintenance cost" },
    thousand: { ID: 2383, CN: "千元", TR: "thousand" },
    maintenance: { ID: 2384, CN: "维护和维修", TR: "maintenance" },
    runningCost: { ID: 541, CN: "运行费用", TR: "operating cost" },
    downtimeAndLoss: { ID: 539, CN: "生产停工和损耗", TR: "downtime and loss" },
    environmentalFee: { ID: 540, CN: "环境保护费", TR: "environmental fee" },
    othersFee: { ID: 777, CN: "其他年费用", TR: "other years expenses" },
    initialCost: {
      ID: 548,
      CN: "一次性初始成本",
      TR: "disposable initial cost",
    },
    orderCost: { ID: 2385, CN: "设备采购费用", TR: "order cost" },
    installDebugCharge: {
      ID: 550,
      CN: "安装和调试",
      TR: "install debug charge",
    },
    tonAndkW: { ID: 2386, CN: "吨/万千瓦", TR: "ton / 10000 kw" },
    mapOfCosts: { ID: 925, CN: "费用图", TR: "Map of costs" },
    costItem: { ID: 929, CN: "费用项", TR: "Cost item" },
    cost: { ID: 930, CN: "费用", TR: "Cost" },
    percentage: { ID: 931, CN: "百分比", TR: "Percentage" },
    maintenanceAndRepair: {
      ID: 542,
      CN: "维修和护理",
      TR: "Maintenance and repair",
    },
    co2: { ID: "", CN: "CO2", TR: "CO2" },
    coalConsumption: { ID: 2388, CN: "煤耗量", TR: "Coal consumption" },
    totalAnnualCost: { ID: 942, CN: "年总费用", TR: "Total annual cost" },
    co2TotalEmissions: {
      ID: 2389,
      CN: "co2总排放量",
      TR: "CO2 total emissions",
    },
    tenThousand: { ID: 940, CN: "万", TR: "Ten thousand" },
    tenThousandTon: { ID: 2390, CN: "万吨", TR: "Ten thousand Ton" },
    calculationPeriod: {
      ID: "",
      CN: "请输入计算周期",
      TR: "Please enter the calculation period!",
    }, //yy ---add
    scaleTime: {
      ID: "",
      CN: "请输入时间比例!",
      TR: "Please enter the time ratio!",
    },
    sumProportions: {
      ID: "",
      CN: "请输入时间比例之和为100%!",
      TR: "Please input the sum of time ratios as 100%!",
    },
    electricCharge: {
      ID: "",
      CN: "请输入电费(每度)!",
      TR: "Please enter the electricity fee (per kWh)!",
    },
    coefficient_c: {
      ID: "",
      CN: "请输CO2系数!",
      TR: "Please input the CO2 coefficient!",
    },
    conversionCoefficient: {
      ID: "",
      CN: "请输入煤炭折算系数!",
      TR: "Please enter the coal conversion factor!",
    },
  },
  //首页
  indexPage: {
    corpIntroduction: { ID: 30, CN: "公司介绍", TR: "Company Introduction" },
    basicInformation: { ID: "", CN: "基础信息", TR: "Basic information" },
    enterpriseHonors: { ID: 32, CN: "企业荣誉", TR: "Enterprise Honors" },
    enterpriseStyle: { ID: 2286, CN: "企业风貌", TR: "Enterprise style" },
    organizationStructure: {
      ID: "",
      CN: "组织结构",
      TR: "organization structure",
    },
    corporateCulture: { ID: "", CN: "企业文化", TR: "corporate culture" },
    introductionToPumpAnimation: {
      ID: "",
      CN: "泵型动画介绍",
      TR: "Introduction to pump animation",
    },
    companyPortfolio: { ID: "", CN: "公式组合", TR: "Company portfolio" },
    salesNetwork: { ID: 31, CN: "销售网络", TR: "Sales Network" },
    performanceSelection: {
      ID: 2287,
      CN: "水力性能选型",
      TR: "Hydraulic performance selection",
    },
    productSearch: { ID: 771, CN: "产品搜索", TR: "Product search" },
    contactinformation: { ID: 35, CN: "联系方式", TR: "Contact information" },
    myProject: { ID: 1716, CN: "我的项目", TR: "My project" },
    ebook: { ID: 1, CN: "电子样本", TR: "Product Book" },
    pdfFile: { ID: 1717, CN: "纸质样本", TR: "Pdf File" },
    application: { ID: 2391, CN: "行业应用", TR: "Application" },
    intelligentSelection: { ID: 68, CN: "智能选型", TR: "Selection" },
    firePump: { ID: 2289, CN: "消防泵", TR: "Fire pump" },
    flow: { ID: 47, CN: "流量", TR: "Flow" },
    head: { ID: 48, CN: "扬程", TR: "Head" },
    type: { ID: 246, CN: "类型", TR: "Type" },
    more: { ID: 734, CN: "更多", TR: "More" },
    nextStep: { ID: 368, CN: "下一步", TR: "Next" },
    zmSearch: { ID: 2392, CN: "按字母", TR: "By alphabet" },
    alphaList: { ID: "", CN: "字母列表", TR: "Alpha List" },
    byType: { ID: 2337, CN: "按类型", TR: "By type" },
    byIndustry: { ID: 2338, CN: "按行业", TR: "By industry" },
    product: { ID: 721, CN: "产品", TR: "Product" },
    material: { ID: 722, CN: "资料", TR: "Material" },
    byProductLine: { ID: "", CN: "按产品线", TR: "By type" },
    model_3D: { ID: 132, CN: "BIM模型", TR: "Model Base" },
    about_us: { ID: 2393, CN: "关于我们", TR: "About US" },
    product_catalog: { ID: 2394, CN: "产品目录", TR: "Product Catalog" },
    product_selection: { ID: 2395, CN: "产品选型", TR: "Selection" },
    letter_search: { ID: 2396, CN: "字母搜索", TR: "Letter Search" },
    application_HY: { ID: 2391, CN: "行业应用", TR: "Application" },
    application_area: { ID: 2339, CN: "应用领域", TR: "Application Area" },
    sample_Model: { ID: 2397, CN: "样本模型", TR: "Product Book" },

    searchByPumpImg: { ID: "", CN: "按产品图搜索", TR: "Search by pump image" },

    pleaseSelect: { ID: 2022, CN: "请选择", TR: "Please Select" },
    corpInfo: { ID: 1802, CN: "公司信息", TR: "Company information" },
    enterpriseVision: { ID: "", CN: "企业愿景", TR: "Enterprise Vision" },
    coreValues: { ID: "", CN: "核心价值观", TR: "Core Values" },
    managementIdea: { ID: "", CN: "经营理念", TR: "Management Idea" },
    productSeries: { ID: 2320, CN: "产品系列", TR: "Product series" },
    enterpriseInformation: { ID: "", CN: "企业信息", TR: "Corp Information" },
    pipelineLoss: { ID: 325, CN: "管路损失", TR: "Pipeline Loss" },
    clearCache: { ID: "", CN: "清除缓存", TR: "Clear cache" },
    myCollection: { ID: 308, CN: "我的收藏", TR: "My Favorite" },
    compareList: { ID: 840, CN: "比较列表", TR: "Compare list" },
    lang: { ID: 449, CN: "语言", TR: "Language" },
    cn: { ID: 714, CN: "中文", TR: "Chinese" },
    en: { ID: 296, CN: "英文", TR: "English" },
    about: { ID: 2598, CN: "关于", TR: "About" },
    developers: { ID: 40, CN: "软件开发商", TR: "Software Developper" },
    privacyStatement: { ID: "", CN: "隐私声明", TR: "Privacy statement" },
    userAgreement: { ID: "", CN: "用户协议", TR: "User agreement" },
    changePassword: { ID: 23, CN: "修改密码", TR: "Modify Password" },
    LogOut: { ID: 707, CN: "退出登录", TR: "Exit " },
    currentVersion: { ID: 1492, CN: "当前版本", TR: "Current version" },
    top: { ID: 1901, CN: "顶部", TR: "Top" },
    add: { ID: 710, CN: "公司地址", TR: "Company address:" },
    tel: { ID: 2398, CN: "联系电话", TR: "Tel:" },
    email: { ID: 2399, CN: "企业邮箱", TR: "E-mail:" },
    hotline: {
      ID: 2400,
      CN: "全国同一服务热线",
      TR: "National service hotline:",
    },
    helpManual: { ID: "", CN: "帮助手册", TR: "Help manual" },
    viewNow: { ID: 170, CN: "立即查看", TR: "View Now" },
    quick: { ID: "", CN: "快速", TR: "Quick" },
    sampleBook: { ID: "", CN: "产品样本", TR: "Sample Book" },
    simpleAndDirect: { ID: "", CN: "清晰简捷", TR: "Simple and direct" },
    clearClassification: { ID: "", CN: "分类明确", TR: "Clear classification" },
    quickProductSelection: {
      ID: "",
      CN: "产品快速选取",
      TR: "Quick product selection",
    },
    productSamplePreview: {
      ID: "",
      CN: "产品样本预览",
      TR: "Product sample Preview",
    },
    productNameAtoZ: { ID: "", CN: "产品名称A-Z", TR: "Product name A-Z" },
    findApplications: {
      ID: "",
      CN: "发现适合您需求的应用",
      TR: "Find applications that fit your needs",
    },
    feedBack: { ID: "", CN: "问题反馈", TR: "FeedBack" },
    feedbackContent: { ID: "", CN: "反馈内容", TR: "Feedback Content" },
    feedbackRule: {
      ID: "",
      CN: "联系人或联系方式不能为空",
      TR: "Contact or contact information cannot be blank!!",
    },
    problemType: { ID: "", CN: "问题类型", TR: "Problem type" },
    rorExample: {
      ID: "",
      CN: "例如：软件问题、曲线错误",
      TR: "For example: software problems, curve errors",
    },
    classAndSelection: {
      ID: "",
      CN: "分类选型",
      TR: "Classification and selection",
    },
    industrySelection: { ID: "", CN: "行业选型", TR: "Industry Selection" },
    projectList: { ID: "", CN: "项目列表", TR: "Project List" },
    customerList: { ID: "", CN: "客户列表", TR: "Customer List" },

    intelligentSelectionSub: {
      ID: "",
      CN: "根据参数筛选，精准选出所需的型号",
      TR: "Based on parameter screening, accurately select the required model",
    },
    marketSector: { ID: "", CN: "市场领域", TR: "Market Sector" },
    marketSectorSub: {
      ID: "",
      CN: "根据设备应用领域，呈现所需的型号",
      TR: "Present the required models based on the application field of the device",
    },
    alphabeticSort: { ID: "", CN: "字母排序", TR: "Alphabetic" },
    alphabeticSortSub: {
      ID: "",
      CN: "根据字母排序，罗列所有的设备系列",
      TR: "List all device series in alphabetical order",
    },
    enterSelect: { ID: "", CN: "进入选型", TR: "Enter Selection" },
    companyWebsite: { ID: "", CN: "企业官网", TR: "Company Website" },
  },
  //管路计算
  pipeLoss: {
    back: { ID: "", CN: "返回", TR: "back" },
    selparas: { ID: 5, CN: "参数选型", TR: "Parameter Selection" },
    previous: { ID: 367, CN: "上一步", TR: "Previous" },
    nextStep: { ID: 368, CN: "下一步", TR: "Next" },
    flowRule: { ID: 2143, CN: "请输入流量", TR: "Please input flow" },
    flow: { ID: 47, CN: "流量", TR: "Flow" },
    head: { ID: 48, CN: "扬程", TR: "Head" },
    medium: { ID: 1448, CN: "介质", TR: "Medium" },
    mediaRule: { ID: "", CN: "请输入介质", TR: "Please enter media" },
    selectType: { ID: 2462, CN: "所选类型", TR: "Select type" },
    selectTypeRule: { ID: "", CN: "请选择类型", TR: "Please select type" },
    pipeWallThicknessNo: {
      ID: 2541,
      CN: "管壁厚度号",
      TR: "Pipe wall thickness No",
    },
    inletPipe: { ID: "", CN: "进水管", TR: "Inlet pipe" },
    drainagePipe: { ID: "", CN: "排水管", TR: "Drainage pipe" },
    RCOIP: {
      ID: "",
      CN: "进水管阻力系数",
      TR: "Resistance coefficient of inlet pipe",
    },
    DPRC: {
      ID: "",
      CN: "排水管阻力系数",
      TR: "Drainage pipe resistance coefficient",
    },
    suctionconfig: { ID: 2497, CN: "吸入配置", TR: "Suction configuration" },
    atmospheric: { ID: 2531, CN: "大气压", TR: "atmospheric pressure" },
    WTSP: { ID: 2532, CN: "水塔表面压力", TR: "Water tower surface pressure" },
    waterAbsorptionHeight: {
      ID: "",
      CN: "吸水高度",
      TR: "Water absorption height",
    },
    PipelineLength: { ID: 2474, CN: "管路长度", TR: "Pipeline length" },
    entrance: { ID: 2520, CN: "入口", TR: "entrance" },
    export: { ID: 2521, CN: "出口", TR: "Export" },
    elbow_90: { ID: 2522, CN: "90°弯头", TR: "90°elbow" },
    ballValve: { ID: 2523, CN: "球阀", TR: "ball valve" },
    butterflyValve: { ID: 2524, CN: "蝶阀", TR: "butterfly valve" },
    gateValve: { ID: 2525, CN: "闸阀", TR: "Gate valve" },
    globeValve: { ID: 2526, CN: "截止阀", TR: "Globe valve" },
    plugValve: { ID: 2527, CN: "旋塞阀", TR: "Plug valve" },
    liftCheckValve: { ID: 2528, CN: "升降式止回阀", TR: "Lift check valve" },
    stopCheckValve: { ID: 2529, CN: "截止止回阀", TR: "Stop check valve" },
    swingCheckValve: { ID: 2530, CN: "旋启式止回阀", TR: "Swing check valve" },
    dischargeConfig: {
      ID: 2498,
      CN: "排出配置",
      TR: "Discharge configuration",
    },
    staticDischargeHead: {
      ID: 2537,
      CN: "静排出扬程",
      TR: "Static discharge head",
    },
    calcResults: { ID: 2499, CN: "计算结果", TR: "Calculation results" },
    designPoint: { ID: 2538, CN: "设计点", TR: "Design point" },
    pipeSize: { ID: 2547, CN: "管路尺寸", TR: "Pipe size" },
    localLoss: { ID: 2548, CN: "局部损失", TR: "Local loss" },
    LATWIP: {
      ID: 2550,
      CN: "进水管路沿程损失",
      TR: "Loss along the water inlet pipeline",
    },
    LATWOP: {
      ID: "",
      CN: "出水管路沿程损失",
      TR: "Loss along the water outlet pipeline",
    },
    FCOIP: {
      ID: 2549,
      CN: "进水管路摩擦系数",
      TR: "Friction coefficient of inlet pipeline",
    },
    FCOOP: {
      ID: "",
      CN: "出水管路摩擦系数",
      TR: "Friction coefficient of outlet pipeline",
    },
    pipe: { ID: 2551, CN: "管路", TR: "Pipe" },
    materialsAndStandards: {
      ID: 2540,
      CN: "材料及标准",
      TR: "Materials and standards",
    },
    withSuctionHead: { ID: "", CN: "有吸水扬程", TR: "With suction head" },
    suctionSystem: { ID: "", CN: "抽吸系统", TR: "Suction system" },
    divingSystem: { ID: "", CN: "潜水系统", TR: "Diving system" },
    circulatorySystem: { ID: "", CN: "循环系统", TR: "circulatory system" },
    simpleCalculation: { ID: "", CN: "简易计算", TR: "Simple calculation" },
    liquidHeight: { ID: "", CN: "液面高度", TR: "Liquid height" },
    fluidName: { ID: "", CN: "流体名称", TR: "Fluid name" },
    pipeDiameter: { ID: "", CN: "管道直径", TR: "Pipe diameter" },
    totalPipeLength: { ID: "", CN: "管道总长", TR: "Total pipe length" },
    viscosity: { ID: 205, CN: "粘度", TR: "Viscosity" },
    proportion: { ID: "", CN: "比重", TR: "proportion" },
    altitude: { ID: "", CN: "高程", TR: "altitude" },
    pressureDrop: { ID: "", CN: "计算压力降为", TR: "Pressure drop" },
    calc: { ID: 333, CN: "计算", TR: "Calculation" },
    bend_90: { ID: "", CN: "90°弯管", TR: "90 ° bend" },
    bend_45: { ID: "", CN: "45°弯管", TR: "45 ° bend" },
    threeWayBranches: { ID: "", CN: "三通分流数", TR: "three-way branches" },
    numberOfTeeLines: { ID: "", CN: "三通线流数", TR: "Number of tee lines" },
    angleValves: { ID: "", CN: "角阀", TR: "angle valves" },
    checkValve: { ID: "", CN: "止回阀", TR: "check valve" },
    pcs: { ID: "", CN: "只", TR: "PCS" },
    returnPipe: { ID: "", CN: "回水管", TR: "Return pipe" },
    load: { ID: "", CN: "载荷", TR: "load" },
    staticSuctionHead: {
      ID: 2533,
      CN: "静吸入扬程",
      TR: "Static suction head",
    },
    stbmylRule: {
      ID: 2574,
      CN: "请输入水塔表面压力",
      TR: "Please enter the surface pressure of water tower",
    },
    xsgdRule: {
      ID: 2577,
      CN: "请输入吸水高度",
      TR: "Please enter the suction height",
    },
    pipeLength: {
      ID: 2584,
      CN: "请输入管路长度",
      TR: "Please enter the pipe length",
    },
  },
  simpleLoginPage: {
    login: { ID: 673, CN: "登录", TR: "Login" },
    register: { ID: 380, CN: "注册", TR: "Register" },
    enterVerificCode: {
      ID: 2401,
      CN: "请输入验证码",
      TR: "Please enter the verification code",
    },
    verificCodeError: {
      ID: 2402,
      CN: "验证码错误",
      TR: "Verification code error",
    },
    loginPrompt: { ID: 2403, CN: "登录提示", TR: "Login Prompt" },
    passwordError: { ID: 400, CN: "密码错误", TR: " Password Error" },
    loginSuccessful: {
      ID: 2404,
      CN: "登录成功,正在跳转~",
      TR: "Login succeeded, skipping~",
    },
    AccountLogin: { ID: 2405, CN: "账户登录", TR: "User login" },
    CodeScanningLogin: { ID: 2290, CN: "扫码登录", TR: "Code scan login" },
    registerInfo: {
      ID: 2291,
      CN: "如果您还没有加入我们，可以点击下方的注册成为我们的一员",
      TR: "If you haven't joined us yet, you can click the registration below to become a member of us",
    },
    registerInfoTitle: { ID: 2292, CN: "新用户", TR: "New user" },
    loginInfo: {
      ID: 2293,
      CN: "如果您已经是我们中的一员可以点击下方的登录，进入到我们的平台",
      TR: "If you are already one of us, you can click the login below to enter our platform",
    },
    loginInfoTitle: { ID: 2294, CN: "我们中的一员", TR: "One of us" },
    userType: { ID: 2295, CN: "用户类型", TR: "Type" },
    loginName: { ID: 2296, CN: "账户名", TR: "Account" },
    password: { ID: 378, CN: "密码", TR: "Password" },
    userType0: { ID: 703, CN: "内部人员", TR: "Internal staff" },
    userType1: { ID: 2297, CN: "外部人员", TR: "External personnel" },
    userType2: { ID: "", CN: "代理商", TR: "Agent" },
    phoneNumber: { ID: 379, CN: "手机号", TR: "Tel" },
    email: { ID: 1803, CN: "邮箱", TR: "Email" },
    forgetPassword: { ID: "", CN: "忘记密码", TR: "Forget password" },
    sendSuccess: { ID: "", CN: "发送成功", TR: "Send success" },
    verifyAccount: { ID: "", CN: "账号验证", TR: "Verify account" },
    fillInInformation: { ID: "", CN: "填写信息", TR: "Fill in information" },
    registerSuccess: { ID: 890, CN: "注册成功", TR: "Register success" },
    registerTips: {
      ID: "",
      CN: "请填写您注册时的手机号",
      TR: "Please fill in your mobile phone number when registering",
    },
    forgetEmailTips: {
      ID: "",
      CN: "请填写您注册时的邮箱",
      TR: "Please fill in your email address when registering",
    },
    verifyCode: { ID: 700, CN: "验证码", TR: "verifyCode" },
    send: { ID: "", CN: "发送", TR: "send" },
    userAccount: { ID: "", CN: "用户账号", TR: "User account" },
    oldPassword: { ID: "", CN: "旧密码", TR: "Old password" },
    oldPsdTips: { ID: "", CN: "请输入旧密码", TR: "Please enter old password" },
    newPassword: { ID: 397, CN: "新密码", TR: "New password" },
    newPsdTips: { ID: "", CN: "请输入新密码", TR: "Please enter new password" },
    oldPwdRule: {
      ID: "",
      CN: "旧密码不能为空",
      TR: "Old password cannot be empty",
    },
    newPwdRule: {
      ID: "",
      CN: "新密码不能为空",
      TR: "New password cannot be empty",
    },
    oldAndNewPwdRule: {
      ID: "",
      CN: "新旧密码不能一致",
      TR: "Old and new passwords cannot be consistent",
    },
    enterPwdAgain: {
      ID: 2303,
      CN: "请再次输入密码",
      TR: "Please enter the password again",
    },
    enterTwoPwdDisaccord: {
      ID: "",
      CN: "两次输入密码不一致",
      TR: "The two passwords were not the same",
    },
    changeSuccess: { ID: 636, CN: "修改成功", TR: "Modified successfully" },
    pwdRule: { ID: 399, CN: "密码不一致", TR: "Inconsistent passwords" },
    accountSettings: { ID: "", CN: "账号设置", TR: "Account Settings" },
    confirmPassword: { ID: "", CN: "确定密码", TR: "Confirm password" },
    realName: { ID: "", CN: "用户名", TR: "Real Name" },
    corpName: { ID: 102, CN: "公司名称", TR: "Corporate Name" },
    corpAddress: { ID: 710, CN: "公司地址", TR: "Company address" },
    welcomeLogin: {
      ID: "",
      CN: "注册成功，欢迎登录",
      TR: "Registration succeeded. Welcome to login",
    },
    returnLogin: { ID: "", CN: "返回登录", TR: "Return to login" },
    accountDeteld: { ID: "", CN: "账户注销", TR: "Account Deleted" },
    formValidate: {
      email0: { ID: 773, CN: "请输入邮箱", TR: "Input Email" },
      email1: {
        ID: 2298,
        CN: "请输入正确的邮箱格式",
        TR: "Please enter the correct email format",
      },
      TelPhone0: {
        ID: 2299,
        CN: "请输入手机号码",
        TR: "Please enter your mobile phone number",
      },
      TelPhone1: {
        ID: 2300,
        CN: "请输入正确的手机号码格式",
        TR: "Please enter the correct mobile phone number format",
      },
      pass0: { ID: 2301, CN: "请输入密码", TR: "Please input a password" },
      pass1: {
        ID: 2302,
        CN: "请输入密码长度为6~18位",
        TR: "Please enter a password with a length of 6 ~ 18 digits",
      },
      pass2: {
        ID: 2303,
        CN: "请再次输入密码",
        TR: "Please enter the password again",
      },
      pass3: {
        ID: 2304,
        CN: "两次密码输入不一样",
        TR: "The two passwords are different",
      },
      pass4: {
        ID: "",
        CN: "密码必须包含大写或小写字母、数字、特殊字符",
        TR: "Passwords must contain uppercase or lowercase letters, numbers, and special characters",
      },
      loginName0: {
        ID: 2305,
        CN: "请输入登录名",
        TR: "Please enter login name",
      },
      loginName1: {
        ID: 2306,
        CN: "请输入登录名长度为6~18位",
        TR: "Please enter a login with a length of 6 ~ 18 characters",
      },
      userName0: {
        ID: 2307,
        CN: "请输入用户姓名",
        TR: "Please enter user name",
      },
      corpName0: {
        ID: 2307,
        CN: "请输入公司名称",
        TR: "Please enter company name",
      },
      corpAddress0: {
        ID: "",
        CN: "请输入公司地址",
        TR: "Please enter the company address",
      },
      tips1: {
        ID: "",
        CN: "不能包含特殊符号'或（）或*",
        TR: "Cannot contain special symbol 'or () or  *",
      },
    },
  },
  // 头部header栏
  header: {
    serieslist: { ID: 1, CN: "电子样本", TR: "Product Book" },
    selparas: { ID: 5, CN: "参数选型", TR: "Parameter Selection" },
    lang: { ID: 449, CN: "语言", TR: "Language" },
    cn: { ID: 714, CN: "中文", TR: "Chinese" },
    en: { ID: 296, CN: "英文", TR: "English" },
    ko: { ID: 299, CN: "韩文", TR: "Korean" },
    es: { ID: 2360, CN: "西班牙文", TR: "Spanish" },
    russian: { ID: 302, CN: "俄文", TR: "Russian" },
    Applications: { ID: 2309, CN: "其他应用", TR: "Other applications" },
    danji: { ID: 2310, CN: "单机版", TR: "Stand alone" },
    android: { ID: 2311, CN: "安卓", TR: "Android" },
    ios: { ID: 2312, CN: "苹果", TR: "IOS" },
    wechat: { ID: 2313, CN: "微信", TR: "Wechat" },
    userInfo: { ID: 2423, CN: "账户信息", TR: "Information" },
    logout: { ID: 707, CN: "退出登录", TR: "Exit" },
    collectList: { ID: 2406, CN: "收藏列表", TR: "CollectList" },
    compareList: { ID: 840, CN: "比较列表", TR: "CompareList" },
    collect: { ID: 1705, CN: "收藏", TR: "Collect" },
    addCollect: { ID: 2407, CN: "加入收藏", TR: "AddCollect" },
    deleteCollect: { ID: 842, CN: "清除收藏", TR: "DeleteCollect" },
    compare: { ID: 691, CN: "比较", TR: "Compare" },
    addCompare: { ID: 839, CN: "加入比较", TR: "AddCompare" },
    deleteCompare: { ID: 841, CN: "清除比较", TR: "DeleteCompare" },
    comparisonAdded: {
      ID: 2408,
      CN: "已经加入比较列表",
      TR: "comparison added list",
    },
    addComparSueecss: {
      ID: 2409,
      CN: "加入比较列表成功",
      TR: "successfully added to the comparison list",
    },
    clearComparList: {
      ID: 2410,
      CN: "确认清除比较列表",
      TR: "confirm to clear the comparison list",
    },
    clearComparSuccess: {
      ID: 2411,
      CN: "清除比较列表成功",
      TR: "the comparison list was cleared successfully",
    },
    confirmDelCompar: {
      ID: 2412,
      CN: "确认删除此型号的比较",
      TR: "confirm to delete the comparison of this model",
    },
    deleteSuccess: { ID: 2413, CN: "删除成功", TR: "deleted successfully" },
    confirmDelCollect: {
      ID: 2414,
      CN: "确认删除此收藏",
      TR: "are you sure you want to delete this collection",
    },
    confirmClearCollect: {
      ID: 2415,
      CN: "确认清除收藏",
      TR: "confirm to clear the collection",
    },
    clearCollectSueecss: {
      ID: 2416,
      CN: "清除成功",
      TR: "Cleared successfully",
    },
    collecExists: {
      ID: 2417,
      CN: "收藏已存在",
      TR: "collection already exists",
    },
    collectSuccess: { ID: 2418, CN: "收藏成功", TR: "Collection success" },
    login: { ID: 673, CN: "登录", TR: "Login" },
    information: { ID: 2419, CN: "个人信息", TR: "Information" },
    tipInfo: {
      ID: 2420,
      CN: "您确定要退出系统吗",
      TR: "Are you sure you want to exit the system",
    },
    tip: { ID: 289, CN: "提示", TR: "tip" },
    define: { ID: 125, CN: "确定", TR: "ok" },
    cancel: { ID: 126, CN: "取消", TR: "cancel" },
    collectTip: {
      ID: 2421,
      CN: "收藏列表为空",
      TR: "Collection list is empty",
    },
    compareTip: {
      ID: 2422,
      CN: "比较列表至少需要两项",
      TR: "The comparison list requires at least two items",
    },
    accountModification: { ID: "", CN: "账户修改", TR: "accountModification" },
    accountInfo: { ID: 2423, CN: "账户信息", TR: "Account Info" },
    baseInfo: { ID: 424, CN: "基本信息", TR: "Base Info" },
    realName: { ID: 631, CN: "真实姓名", TR: "Real Name" },
    account: { ID: 2424, CN: "账号", TR: "Acccount" },
    telPhoneNumber: { ID: 379, CN: "手机号", TR: "TelPhone Number" },
    email: { ID: 1803, CN: "邮箱", TR: "E-mail" },
    corpName: { ID: 102, CN: "公司名称", TR: "CorpName" },
    corpAddress: { ID: 710, CN: "公司地址", TR: "CorpAddress" },
    code: { ID: "", CN: "编码", TR: "Code" },
    userSetting: { ID: "", CN: "用户设置", TR: "User settings" },
    update: {
      ID: "",
      CN: "检测到有新版本, 是否更新?",
      TR: "New version detected, update?",
    },
    updateFile: {
      ID: "",
      CN: "下载更新文件中...",
      TR: "Download update file...",
    },
    updateFail: {
      ID: "",
      CN: "下载更新文件失败！",
      TR: "Failed to download update file!",
    },
    installFile: { ID: "", CN: "安装更新文件", TR: "Install update files" },
    installCompleted: {
      ID: "",
      CN: "应用资源更新完成！",
      TR: "Application resource update completed!",
    },
    installFail: {
      ID: "",
      CN: "安装更新文件失败",
      TR: "Failed to install update file",
    },
    haveCollected: {
      ID: "",
      CN: "您暂未收藏产品",
      TR: "You haven't collected products yet",
    },
    comparisonRequires: {
      ID: "",
      CN: "比较列表至少需要两项",
      TR: "The comparison list requires at least two items",
    },
    entryName: { ID: "", CN: "项目名称", TR: "entryName" }, //yy add---
    companyYName: { ID: "", CN: "您的公司名", TR: "companyYName" },
    companyType: { ID: "", CN: "类型", TR: "type" },
    constructionParty: { ID: "", CN: "采购方/建设方", TR: "constructionParty" },
    projectLocation: { ID: "", CN: "项目所在地", TR: "projectLocation" },
    projectCity: { ID: "", CN: "城市", TR: "city" },
    projectArea: { ID: "", CN: "县/区", TR: "area" },
    projectDetailAddress: {
      ID: "",
      CN: "详细地址",
      TR: "address",
    },
    projectNotes: { ID: "", CN: "备注说明", TR: "remark" },
    itemName: { ID: "", CN: "项目名", TR: "itemName" }, //项目列表
    itemNo: { ID: "", CN: "项目编号", TR: "projectNo" },
    item_start_EndTime: { ID: "", CN: "开始/结束时间", TR: "start/End Time" },
    ConsumerName: { ID: "", CN: "业主方", TR: "owner" },
    PrjCreateTime: { ID: "", CN: "项目添加时间", TR: "projectAdditionTime" },
    CustomerDistrict: { ID: "", CN: "所属区域", TR: "region" },
    C_Address: { ID: "", CN: "地址", TR: "address" },
    itemQuery: { ID: "", CN: "查询", TR: "query" },
    itemDelete: { ID: "", TR: "删除", TR: "delete" },
  },
  // 底部footer 栏
  footer: {
    version: { ID: 29, CN: "版本", TR: "Version" },
    technical: {
      ID: 697,
      CN: "技术支持：上海义维流体科技有限公司",
      TR: "Technical support: Shanghai EvenTech Fluid Technology Co. Ltd.",
    },
    technicalAddres: {
      ID: "",
      CN: "备案号为：沪ICP备14049296号-2",
      TR: "The filing number is 沪ICP备14049296号-2",
    },
    copyright: {
      ID: "",
      CN: "版权所有：上海义维流体科技有限公司",
      TR: "Copyright：Even Technology Co., Ltd",
    },
    copyrightAddres: {
      ID: "",
      CN: "地址：上海市闵行区江月路999号1幢615",
      TR: "Address: 615, building 1, No. 999, Jiangyue Road, Minhang District, Shanghai",
    },
    tips: {
      ID: 2425,
      CN: "数据仅供参考：如有修改恕不通知 版权所有，盗版必究",
      TR: "The data is for reference only: in case of any modification, we will not notify the copyright owner, and piracy will be prosecuted",
    },
  },
  // 供水项目
  swproject: {
    projectName: { ID: "", CN: "项目名称", TR: "Project Name" },
    dateTime: { ID: "", CN: "日期时间", TR: "Date Time" },
    projectNo: { ID: "", CN: "项目编号", TR: "Project No" },
    customerName: { ID: "", CN: "客户名称", TR: "Customer Name" },
    consumerName: { ID: "", CN: "终端用户", TR: "Consumer Name" },
    quoteTotalMoney: { ID: "", CN: "报价单总金额", TR: "Quote Total Money" },
    createTime: { ID: "", CN: "创建时间", TR: "Create Time" },
    saveTime: { ID: "", CN: "保存时间", TR: "Save Time" },
    inquiryDueDate: { ID: "", CN: "询价截止日期", TR: "Inquiry Due Date" },
    anticipatedOrderDate: {
      ID: "",
      CN: "预计订单日期",
      TR: "Anticipated Order Date",
    },
    operation: { ID: "", CN: "操作", TR: "Operation" },
    editProject: { ID: "", CN: "编辑项目", TR: "Edit" },
    addAuth: { ID: "", CN: "添加权限", TR: "Add Auth" },
    addItem: { ID: "", CN: "添加工位", TR: "Add Item" },
    query: { ID: "", CN: "查询", TR: "Query" },
    add: { ID: "", CN: "添加", TR: "Add" },
    basicQuoteInformation: {
      ID: "",
      CN: "基本信息",
      TR: "Basic Quote Information",
    },
    quoteNumber: { ID: "", CN: "报价单编号", TR: "Quote number" },
    quoteStatus: { ID: "", CN: "报价状态", TR: "Quote status" },
    projectStage: { ID: "", CN: "项目阶段", TR: "Project Stage" },

    classSale: { ID: "", CN: "报价状态", TR: "Class Sale" },
    quoteDisposition: { ID: "", CN: "报价处理", TR: "Quote Disposition" },
    actualCloseDate: { ID: "", CN: "实际关闭日期", TR: "Actual Close Date" },
    quoteDispositionStatus: {
      ID: "",
      CN: "报价处理状态",
      TR: "Quote Disposition Status",
    },
    quoteDispositionReason: {
      ID: "",
      CN: "报价处理原因",
      TR: "Quote Disposition Reason",
    },
    quoteDispositionComments: {
      ID: "",
      CN: "报价处理建议",
      TR: "Quote Disposition Comments",
    },
    customerAndEndUser: {
      ID: "",
      CN: "客户与终端用户",
      TR: "Customer And EndUser",
    },
    customerName: { ID: "", CN: "客户名称", TR: "Customer Name" },
    endUser: { ID: "", CN: "终端用户", TR: "End user" },
    countryOfInstallation: {
      ID: "",
      CN: "国内/外",
      TR: "Country Of Installation",
    },
    country: { ID: "", CN: "国家", TR: "Country" },
    province: { ID: "", CN: "省", TR: "Province" },
    city: { ID: "", CN: "市", TR: "City" },
    area: { ID: "", CN: "区", TR: "Area" },
    addressDetail: { ID: "", CN: "详细地址", TR: "Address Detail" },
    customerContact: { ID: "", CN: "联系方式", TR: "Customer Contact" },
    quotationTimeLine: { ID: "", CN: "报价时间线", TR: "Quotation Time Line" },
    inquiryReceivedDate: {
      ID: "",
      CN: "询价接收日期",
      TR: "Inquiry received date",
    },
    inquiryDueDate: { ID: "", CN: "询价截止日期", TR: "Inquiry due date" },
    anticipatedOrderDate: {
      ID: "",
      CN: "预计订单日期",
      TR: "Anticipated order date",
    },
    actualQuoteSubmittedDate: {
      ID: "",
      CN: "实际报价提交日期",
      TR: "Actual quote submitted date",
    },
    salesInformationSecurity: {
      ID: "",
      CN: "销售信息&安全",
      TR: "Sales Information & Security",
    },
    quoteCurrency: { ID: "", CN: "报价货币", TR: "Quote currency" },
    deliveryPort: { ID: "", CN: "交货港口", TR: "Delivery port" },
    transaction: { ID: "", CN: "交易方式", TR: "Transaction" },
    exchangeRate: { ID: "", CN: "汇率", TR: "Exchange Rate" },
    otherEditors: { ID: "", CN: "其他编辑者", TR: "Other editors" },
    available: { ID: "", CN: "可选的", TR: "Available" },
    selected: { ID: "", CN: "选中的", TR: "Selected" },
    other: { ID: "", CN: "其他", TR: "Selected" },
    save: { ID: "", CN: "保存", TR: "Save" },
    headSculpture: { ID: "", CN: "头像", TR: "Head sculpture" },
    no: { ID: "", CN: "编号", TR: "No" },
    name: { ID: "", CN: "名称", TR: "Name" },
    usageState: { ID: "", CN: "使用状态", TR: "Usage State" },
    location: { ID: "", CN: "位置", TR: "Location" },
    address: { ID: "", CN: "详细地址", TR: "Address" },
    back: { ID: "", CN: "返回", TR: "back" },
    automatically: { ID: "", CN: "自动生成", TR: "Automatically" },
    marketType: { ID: "", CN: "市场类型", TR: "Market Type" },
    clearSelect: {
      ID: "",
      CN: "清空所选收藏列表",
      TR: "Clear the selected favorites list",
    },
  },
  // 简易项目
  simpleProject: {
    tips1: {
      ID: "",
      CN: "请至少选中一个型号",
      TR: "Please select at least one model",
    },
    tips2: { ID: "", CN: "确认返回？", TR: "Confirm return" },
    tips3: {
      ID: "",
      CN: "确认删除此型号吗？",
      TR: "Are you sure to delete this model?",
    },
    tips4: { ID: "", CN: "添加失败", TR: "Add failed" },
    tips5: { ID: "", CN: "添加成功", TR: "Added successfully" },
    tips6: {
      ID: "",
      CN: "清除收藏列表",
      TR: "Clear the selected favorites list?",
    },
    auto: { ID: "", CN: "自动生成", TR: "Auto" },
    someAsCustomer: { ID: "", CN: "和客户一样", TR: "Some As Customer" },
    itemInfo: { ID: "", CN: "工位信息", TR: "Item information" },
    creator: { ID: "", CN: "创建人", TR: "Creator" },

    upload: { ID: "", CN: "上传", TR: "Upload" },
    notUpload: { ID: "", CN: "未上传", TR: "Not uploaded" },
    lastEditor: { ID: "", CN: "最后编辑人", TR: "Last editor" },
    tips7: {
      ID: "",
      CN: "项目名称不能为空",
      TR: "Project name cannot be empty",
    },
    tips8: {
      ID: "",
      CN: "此操作将删除该项目, 是否继续?",
      TR: "This operation will delete the project. Do you want to continue",
    },
    tips9: {
      ID: "",
      CN: "无法读取到项目信息",
      TR: "Unable to read project information",
    },
    tips10: { ID: "", CN: "删除失败", TR: "Delete failed" },
    tips11: { ID: "", CN: "删除成功", TR: "Delete successful" },
    tips12: {
      ID: "",
      CN: "已取消删除操作",
      TR: "The deletion operation has been canceled",
    },
    tips13: { ID: "", CN: "用户名称不能为空", TR: "User name cannot be empty" },
    tips14: { ID: "", CN: "请填选客户", TR: "Please select the customer" },

    tips15: { ID: "", CN: "修改成功", TR: "Modified successfully" },
    tips16: { ID: "", CN: "修改失败", TR: "Modification failed" },
    tips17: {
      ID: "",
      CN: "此操作将清空已填信息, 是否继续?",
      TR: "This operation will clear the filled information. Do you want to continue?",
    },
    tips18: { ID: "", CN: "已取消操作", TR: "Operation canceled" },
  },
  //快速选型-大元
  quickSelection: {
    pressurize: { ID: 923, CN: "增压", TR: "Pressurize" },
    groundWater: { ID: "", CN: "地下水", TR: "Ground Water" },
    wasteWater: { ID: "", CN: "废水", TR: "Waste Water" },
    liftingStation: { ID: "", CN: "提升站", TR: "Lifting Station" },
    quickSelection: { ID: "", CN: "快速选型", TR: "Quick Selection" },
    inletPressureType: {
      ID: "",
      CN: "入口压力类型",
      TR: "Inlet pressure type",
    },
    pressurizeType1: {
      ID: "",
      CN: "屋顶水箱供水增压",
      TR: "Roof water tank supply pressurization",
    },
    pressurizeType2: {
      ID: "",
      CN: "水箱供水增压",
      TR: "Water tank supply pressurization",
    },
    pressurizeType3: { ID: "", CN: "市政供水", TR: "Municipal water supply" },
    pressurizeType4: {
      ID: "",
      CN: "负压小于8米",
      TR: "Negative pressure less than 8 meters",
    },
    selectionParams: { ID: "", CN: "选型参数", TR: "Selection parameters" },
    stopcocks: { ID: "", CN: "水龙头数", TR: "stopcocks" },
    floors: { ID: "", CN: "楼层数", TR: "floors" },
    tappingPoint: { ID: "", CN: "分接点", TR: "Tapping point" },
    houseType: { ID: "", CN: "房屋类型", TR: "House Type" },
    tapPressure: { ID: "", CN: "水龙头压力", TR: "Tap Pressure" },
    singleStoryHouses: { ID: "", CN: "单层房屋", TR: "Single Story Houses" },
    doubleDeckerHouse: { ID: "", CN: "双层房屋", TR: "Double Decker House" },
    outdoorPipelineMaterials: {
      ID: "",
      CN: "室外管道材料",
      TR: "Outdoor Pipeline Materials",
    },
    outdoorPipelineDiameter: {
      ID: "",
      CN: "室外管道口径",
      TR: "Outdoor Pipeline Diameter",
    },
    outdoorPipelineLength: {
      ID: "",
      CN: "室外管道长度",
      TR: "Outdoor Pipeline Length",
    },
    indoorPipelineLength: {
      ID: "",
      CN: "室内管道长度",
      TR: "Indoor Pipeline Length",
    },
    pressureHeadSize: {
      ID: "",
      CN: "压头大小确定",
      TR: "Determination Of Pressure Head Size",
    },
    crossSectionalArea: {
      ID: "",
      CN: "横截面积确定",
      TR: "Determination of cross-sectional area",
    },
    plasticPipe: { ID: "", CN: "塑料管", TR: "Plastic Pipe" },
    maxTappingHeight: {
      ID: "",
      CN: "最高分接点高度",
      TR: "Maximum Tapping Point Height",
    },
    buildingHeight: { ID: "", CN: "房屋高度", TR: "Building Height" },
    wellheadHeight: { ID: "", CN: "井口高度", TR: "Wellhead Height" },
    dynamicWaterLevel: {
      ID: "",
      CN: "动态水位高度",
      TR: "Dynamic Water Level Height",
    },
    powerSupply: { ID: "", CN: "电源", TR: "Power Supply" },
    houseCableEntry: { ID: "", CN: "房屋电缆入口", TR: "House Cable Entry" },
    cableCrossSectionalArea: {
      ID: "",
      CN: "房屋电缆入口",
      TR: "Cable cross-sectional Area",
    },
    tips1ByGroundWater: {
      ID: "",
      CN: "请确定压头大小",
      TR: "Please determine the size of the pressure head",
    },
    tips2ByGroundWater: {
      ID: "",
      CN: "请选择房屋类型",
      TR: "Please select the type of house",
    },
    tips3ByGroundWater: {
      ID: "",
      CN: "请确认电缆总长度",
      TR: "Please confirm the total length of the cable",
    },
    tips4ByGroundWater: {
      ID: "",
      CN: "未查询到满足条件的泵",
      TR: "No pumps that meet the criteria were found",
    },
    drainage: { ID: "", CN: "排水", TR: "Drainage" },
    drainageType: { ID: "", CN: "排水类型", TR: "Drainage Type" },
    sewage: { ID: "", CN: "污水", TR: "Sewage" },
    sewageOrWastewater: { ID: "", CN: "污水/废水", TR: "Sewage/wastewater" },
    maxConveyingDistance: {
      ID: "",
      CN: "最大输送距离",
      TR: "Maximum conveying distance",
    },
    pressureTip: {
      tip1: { ID: "", CN: "入口压力类型", TR: "Type of inlet pressure" },
      tip2: {
        ID: "",
        CN: "选择所需的压力类型情况",
        TR: "Select the required type of pressure situation",
      },
      tip3: {
        ID: "",
        CN: "输入水龙头数和楼层数",
        TR: "Enter the number of faucets and floors",
      },
      tip4: { ID: "", CN: "选型结果", TR: "Selection results" },
      tip5: {
        ID: "",
        CN: "此块区域可查看符合条件的选型结果",
        TR: "This area allows you to view the selection results that meet the criteria",
      },
      tip6: {
        ID: "",
        CN: "请输入楼层数",
        TR: "Please enter the number of floors",
      },
      tip7: {
        ID: "",
        CN: "请输入水龙头数",
        TR: "Please enter the number of faucets",
      },
    },
    groundWaterTip: {
      tip1: {
        ID: "",
        CN: "根据情况输入参数",
        TR: "Input parameters according to the situation",
      },
      tip2: { ID: "", CN: "压头确定", TR: "Determination of pressure head" },
      tip3: { ID: "", CN: "压头A", TR: "Head A" },
      tip4: { ID: "", CN: "压头B", TR: "Head B" },
      tip5: { ID: "", CN: "压头C", TR: "Head C" },
      tip6: {
        ID: "",
        CN: "确定横截面积",
        TR: "Determine cross-sectional area",
      },
      tip7: {
        ID: "",
        CN: "根据情况输入各段的电缆长度",
        TR: "Enter the cable length for each section according to the situation",
      },
      tip8: { ID: "", CN: "电缆E", TR: "Cable E" },
      tip9: { ID: "", CN: "电缆D", TR: "Cable D" },
      tip10: { ID: "", CN: "电缆F", TR: "Cable F" },
      tip11: { ID: "", CN: "获取选型结果", TR: "Obtain selection results" },
      tip12: {
        ID: "",
        CN: "点击选型按钮获取选型结果",
        TR: "Click the selection button to obtain the selection result",
      },
      tip13: {
        ID: "",
        CN: "根据情况输入需要的各段压头值。",
        TR: "Enter the required pressure head values for each section according to the situation.",
      },
    },
    wasteWaterTips: {
      tip1: { ID: "", CN: "排水类型类型", TR: "Drainage type type" },
      tip2: {
        ID: "",
        CN: "根据情况选择排水类型",
        TR: "Choose drainage type according to the situation",
      },
      tip3: {
        ID: "",
        CN: "输入压头和最大输送距离",
        TR: "Input pressure head and maximum conveying distance",
      },
      tip4: { ID: "", CN: "选型结果", TR: "Selection results" },
      tip5: {
        ID: "",
        CN: "此块区域可查看符合条件的选型结果",
        TR: "This Region allows you to view the selection results that meet the criteria",
      },
    },
  },
};
